export function storeCatchupDoneEvent(event, currentState, updateState) {
  const existing = currentState.catchupDoneEvents ?? {};
  if (existing[event.eventId] === event.timestamp) {
    return;
  }
  updateState("catchupDoneEvents", { ...existing, [event.eventId]: event.timestamp });
}

export function storeCatchupDoneEvents(events, currentState, updateState) {
  const existing = currentState.catchupDoneEvents ?? {};
  let changed = false;
  for (let i = 0; i < events.length; i++) {
    const event = events[i];
    if (existing[event.eventId] !== event.timestamp) {
      changed = true;
      break;
    }
  }
  if (!changed) {
    return;
  }

  const next = { ...existing };
  for (let i = 0; i < events.length; i++) {
    const event = events[i];
    next[event.eventId] = event.timestamp;
  }
  updateState("catchupDoneEvents", next);
}

export function clearCatchupDoneEvents(updateState) {
  updateState("catchupDoneEvents", {});
}
